<template>
    <form @submit.prevent="search">
		<div class="card">
			<div class="card-body">
				<div class="row">
					<div class="col-md-10">
						<div class="row">
							<div class="form-group col-md-2">
								<label for>Tipo de Fecha:</label>
								<v-select v-model="filter.dateType" :options="dateTypes">
									<span slot="no-options">No se encontraron estados</span>
								</v-select>
							</div>
							<div class="form-group col-md-2">
								<label for>Fecha desde:</label>
								<input id="required-dispatch-date-from" v-model="filter.fromDate" class="form-control"
									type="date" />
							</div>
							<div class="form-group col-md-2">
								<label for>Fecha hasta:</label>
								<input id="required-dispatch-date-to" v-model="filter.toDate" class="form-control"
									type="date" />
							</div>
						</div>
					</div>
					<div class="col-md-2">
						<div class="row align-items-end">
							<div class="form-group col">
								<div class="mt-4 text-right">
									<button class="btn btn-dark ml-2 mt-2">
										<i class="fa fa-search mr-2"></i>Buscar
									</button>
									<button class="btn btn-dark ml-2 mt-2" type="button" @click="reset">
										<i class="fa fa-sync-alt mr-2"></i>Reset
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="card-header text-right" style="float: right">
				<!--<button class="btn btn-success" title="Exportar" type="button" @click="exportXls">
					<i class="fas fa-file-excel mr-2"></i> Exportar
				</button>-->
			</div>
		</div>
	</form>
</template>
<script>
    export default {
        data() {
            return {
                filter: { },
                dateTypes: [
                    'Fecha de Solicitud',
                    'Fecha de Despacho',
                    'Fecha de Arribo'
                ],
            }
        },
        props: ['links'],
        methods: {
            index() {
                this.$emit('index');
            },
            reset() {
                this.filter = {};
                this.$router.push({
                    path: this.$route.path
                })
                
            },
            showModal() {
                this.$emit('showModal', true);
            },
            search() {
                this.filter.search = this.links.search;
                 this.$router.push({
                    path: this.$route.path,
                    query: this.filter
                })
            }
        },
        computed: {
            toDate() {
                return this.$route.query.toDate ? this.$route.query.toDate : "";
                },
            fromDate() {
                return this.$route.query.fromDate ? this.$route.query.fromDate : "";
            }
        }
    }

</script>